import { render, staticRenderFns } from "./EditTextField.vue?vue&type=template&id=71533dc0"
import script from "./EditTextField.vue?vue&type=script&lang=js"
export * from "./EditTextField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports